export default __webpack_public_path__ + "static/media/figuremap54.06c9c865.png";